import React from 'react';

import Map from '../Map/Map';

/**
 * A minimal page that renders only the map component.
 * Useful for testing the canvas renderer in isolation.
 * Access via: /map-only
 */
const MapOnlyPage = () => (
  <div
    className="map"
    style={{
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      top: 0,
      left: 0,
    }}
  >
    <Map />
  </div>
);

export default MapOnlyPage;

